import { render, staticRenderFns } from "./registerAuthor.vue?vue&type=template&id=3229eb93&"
import script from "./registerAuthor.vue?vue&type=script&lang=js&"
export * from "./registerAuthor.vue?vue&type=script&lang=js&"
import style0 from "./registerAuthor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports